// Form Radio Group Web Component
// Passes the "group-name" attribute to all input elements as their "name" attribute
class FormRadioGroup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updateInputNames();
    
    // Watch for attribute changes
    this.observer = new MutationObserver(() => {
      this.updateInputNames();
    });
    
    this.observer.observe(this, {
      attributes: true,
      attributeFilter: ['group-name']
    });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  updateInputNames() {
    const groupName = this.getAttribute('group-name');
    
    if (!groupName) return;
    
    // Find all input elements within this component
    const inputs = this.querySelectorAll('input[type="radio"], input[type="checkbox"]');
    
    inputs.forEach(input => {
      input.setAttribute('name', groupName);
    });
  }
}

// Register the component
customElements.define('form-radio-group', FormRadioGroup);

